import * as React from "react";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
const RenderTypeNotSupported = ({ renderType }) => {
  const onRenderComplete = useContext(RenderCompletionCallback);
  const { t } = useTranslation("enterprise_search");
  useEffect(() => {
    onRenderComplete();
  }, [onRenderComplete]);
  return /* @__PURE__ */ React.createElement("div", null, t("render_type_not_supported.message", { renderType }));
};
export default RenderTypeNotSupported;
